import React from 'react';
import { AssumeHintReason, getAssumeHintMessage } from '../../../types/conversation';
import { WorkspaceThemeClasses } from './workspaceTheme';

interface WorkspaceAssumeHintBannerProps {
  theme: WorkspaceThemeClasses;
  reason: AssumeHintReason;
  assigneeName?: string | null;
  loading?: boolean;
  onAssume: () => void;
  onDismiss: () => void;
}

export const WorkspaceAssumeHintBanner: React.FC<WorkspaceAssumeHintBannerProps> = ({
  theme,
  reason,
  assigneeName,
  loading = false,
  onAssume,
  onDismiss,
}) => {
  return (
    <div
      className={`mb-2 flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 ${theme.accentSoft} ${theme.border}`}
      role="status"
    >
      <p className={`text-sm ${theme.text}`}>
        {getAssumeHintMessage(reason, assigneeName)}
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onDismiss}
          disabled={loading}
          className={`text-xs font-medium px-2 py-1 rounded-md ${theme.muted} hover:opacity-80 disabled:opacity-50`}
        >
          Dispensar
        </button>
        <button
          type="button"
          onClick={onAssume}
          disabled={loading}
          className={`text-xs font-semibold px-3 py-1.5 rounded-lg ${theme.accentBtn} disabled:opacity-50`}
        >
          Assumir conversa
        </button>
      </div>
    </div>
  );
};
